import { Observable } from 'rxjs';
import { CodeCompletionResponse, CodeCompletionSuggestion } from './code-completion.types';

export abstract class CodeCompletionFacade {
  abstract onCellEditorChange(): void;
  abstract fetchCodeCompletion(prompt: string, suffix: string | null): Observable<CodeCompletionResponse>;
  abstract clearCodeCompletionSuggestion(): void;
  abstract acceptCodeCompletionSuggestion(): void;
  abstract rejectCodeCompletionSuggestion(): void;
  abstract getCodeCompletionStreamForCell(cellToken: string): Observable<CodeCompletionSuggestion>;
}
